export default {
    getStream: (state) => (uuid) => {
        return state.streams.find(x => x.uuid === uuid);
    }
}